<template>
  <v-container fluid>
    <v-expansion-panel v-model="panel" expand popout v-if="links && links.length">
      <v-expansion-panel-content v-for="(link, index) in links" :key="index">
        <template v-slot:header>
          <v-layout row wrap>
            <v-flex xs12 class="caption grey--text">
              {{
              moment.utc(link.created_at).local().fromNow()
              }}
            </v-flex>
            <v-flex xs12 class="subheading text-truncate">{{ link.created_for_email }}</v-flex>
          </v-layout>
        </template>
        <v-card>
          <v-card-title>
            <div>
              <span class="font-weight-bold">
                {{ $t('rms_avail_link_expiry_date_label',{
                expiry_date:moment(link.expiry_date).format('D MMM YYYY')
                }) }}
              </span>
              <br />
              <span v-if="!link.is_screener_allowed">
                <span class="blue--text">Note -</span>This link has no access of screeners.
              </span>
              <br />
              <span v-if="!link.is_search_filters_allowed ">
                <span class="blue--text">Note -</span>This link has no access of refine search
              </span>
            </div>
          </v-card-title>

          <v-card-actions v-if="canDoAction()">
            <v-btn
              flat
              fab
              dark
              color="green"
              v-clipboard:copy="getUrl(link.id)"
              v-clipboard:success="copySuccess"
              v-clipboard:error="copyFail"
            >
              <v-icon>$vuetify.icons.rms_copy</v-icon>
            </v-btn>

            <v-btn fab dark flat color="primary" @click="(selected_link = link), (dialog = true)">
              <v-icon>$vuetify.icons.rms_edit</v-icon>
            </v-btn>
            <v-btn
              fab
              dark
              flat
              color="orange"
              @click="selected_link = link, social_network_dialog = true"
            >
              <v-icon>$vuetify.icons.rms_share</v-icon>
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn
              flat
              color="red"
              @click="selected_link = link,expire_dialog = true"
            >{{$t('rms_mark_expire_btn_label')}}</v-btn>
          </v-card-actions>
        </v-card>
      </v-expansion-panel-content>
    </v-expansion-panel>
    <NotFound v-else></NotFound>

    <!-- Edit dialog box -->
    <Edit
      v-model="dialog"
      :dialog="dialog"
      :link="selected_link"
      :timeLimits="timeLimits"
      v-if="dialog"
    ></Edit>

    <!-- Share link on social sites  -->
    <SocialNetworks
      v-if="social_network_dialog"
      :link="selected_link"
      v-model="social_network_dialog"
      :dialog="social_network_dialog"
    ></SocialNetworks>

    <!-- Confirmation dialog when expire link -->
    <ConfirmationDialog
      v-if="expire_dialog"
      v-model="expire_dialog"
      :dialog="expire_dialog"
      :message="$t('warning_before_mark_link_expire')"
      @confirm="markExpire(),expire_dialog = false"
      @cancel="selected_link = null, expire_dialog = false"
    ></ConfirmationDialog>
  </v-container>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import Edit from "@/components/invitation/Edit";
import SocialNetworks from "@/components/invitation/SocialNetworks";
import ConfirmationDialog from "@/components/dialogBox/Confirmation";
import DEFINES from "@/defines";
import NotFound from "@/components/NotFound";
export default {
  name: "activeLinks",
  data() {
    return {
      panel: [true],
      dialog: false,
      expire_dialog: false,
      social_network_dialog: false,
      selected_link: null
    };
  },
  computed: {
    ...mapGetters({
      links: "avails/getActiveLinks",
      userRoleInCompany: "company/userRoleInCompany",
      selected_company_id: "company/getSelected"
    }),
    timeLimits() {
      return this.DEFINES.TIME_LIMITS;
    }
  },
  components: {
    Edit,
    SocialNetworks,
    ConfirmationDialog,
    NotFound
  },
  methods: {
    copySuccess: function() {
      this.$store.dispatch("availLink/copySuccess");
    },
    copyFail: function() {
      this.$store.dispatch("availLink/copyFail");
    },
    getUrl(uuid) {
      return this.$store.getters["availLink/getUrl"]({
        uuid: uuid,
        company_id: this.selected_company_id
      });
    },
    markExpire() {
      this.$store.dispatch("avails/markExpire", {
        id: this.selected_link.id
      });
    },
    canDoAction() {
      let role_in_company = this.userRoleInCompany(this.selected_company_id);
      return [DEFINES.ROLE_OWNER, DEFINES.ROLE_ADMIN].includes(role_in_company);
    }
  }
};
</script>

<style></style>
